<template>
  <el-card  class="box-card" :shadow="shadow" :class="headerVisible?'address-box':'adress-box-no-header'">
      <div slot="header" class="clearfix" v-if="!showAddressForm && headerVisible">
         <span class="fs-15" v-if="address.type!=null">{{address.type.name}}     <span v-if="address.code" class="fs-14 secondary-text"> - No. :{{address.code}}</span></span>
         <el-button v-if = "ctrlVisible" size="mini" circle type="danger" style="float: right;  0;margin-left:10px;" @click="removeAddress(index)"><i class="mdi mdi-delete" style="font-size:15px;"></i></el-button>
         <el-button v-if = "ctrlVisible" size="mini" circle  style="float: right;  0;margin-left:10px;" @click="editAddress(index)"><i class="mdi mdi-lead-pencil" style="font-size:15px;"></i></el-button>
       </div>
       <el-row :gutter="20" v-if="!showAddressForm">
         <el-col :span="21" class="company-fiche-info">
           <el-row>
             <el-col :span="1">
               <i class="mdi mdi-map-marker-outline secondary-text"></i>
             </el-col>
             <el-col :span="23" style="padding-left:5px;">
               <AddressLines :address="address" class="secondary-text fs-14"></AddressLines>
             </el-col>
           </el-row>
          </el-col>
       </el-row>
     <AddressForm :show="showAddressForm" @change="changeAddress" :addressToEdit="address" @cancel="cancel"></AddressForm>
  </el-card>
</template>

<script>
import AddressLines from './Address-Lines'
import AddressForm from '@/components/address/Address-Form'
export default {
	name: 'AddressCard',
	props: {
    address : Object,
    index : Number,
    shadow : {
      type : String,
      default : 'never'
    },
    ctrlVisible : {
      type : Boolean,
      default : true,
    },
    headerVisible : {
      type : Boolean,
      default : true
    }
	},
	data() {
		return {
      showAddressForm : false,
		}
	},
	components : {
    AddressLines,
    AddressForm
  },
	methods : {
    removeAddress(index){
      this.$emit('remove',index);
    },
    editAddress(index){
      this.$emit('clickToAdd');
      this.openAddressForm();
    },
    cancel(){
      this.$emit('cancel');
      this.closeAddressForm();
    },
    changeAddress(address){
      this.$emit('change',{index : this.index, address})
      this.closeAddressForm();
    },
    openAddressForm(){
      this.showAddressForm = true;
    },
    closeAddressForm(){
      this.showAddressForm = false;
    }
	}
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';

address-box {
    min-height:175px;padding:0px;
}

adress-box-no-header {
  min-height:105px;padding:0px;
}



</style>
